import { useNavigate } from 'react-router-dom';
import { SUPPLIER_PATH, deleteSupplier, downloadDetailedSupplierReceipt, downloadSupplierExcelFile, downloadSupplierReceipt, getPageSuppliers, uploadSupplierExcelFile } from '../../api/supplierApi';
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { setSupplierSearchParamsAction } from '../../redux/feature/supplierSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import { GoPlus } from 'react-icons/go';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import DeleteModal from '../../components/DeleteModal';
import { pageModel } from '../../utils/model';
import { MdPayments } from "react-icons/md";
import { IoReceiptSharp } from "react-icons/io5";
import SupplierReceipt from '../../components/supplier/SupplierReceipt';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { formatNumber } from '../../utils/functions';


const SupplierListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [supplierPage, setSupplierPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${SUPPLIER_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${SUPPLIER_PATH}`, false)
    const searchParams = useSelector(state => state.supplier.searchParams)
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();
    const [isOpenReceiptModal, setIsOpenReceiptModal] = useState(false)
    const [receiptSupplier, setReceiptSupplier] = useState()

    useEffect(() => {
        loadSuppliers({ size: 20, page: supplierPage.number, ...searchParams })
    }, [])

    const onLoadMore = () => {
        if (!supplierPage.last) {
            loadSuppliers({ ...searchParams, lastId: supplierPage.content[supplierPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams })
    }, [searchParams])

    const loadSuppliers = (params) => {
        !pendingApiCall &&
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteSupplier(deleteId)
            .then(res => {
                setIsOpen(false)
                setSupplierPage(prevState => ({ ...prevState, content: prevState.content.filter(c => c.id !== res.data.id) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const onClickDownloadReceipt = (firstDate, lastDate) => {
        downloadSupplierReceipt(receiptSupplier.id, firstDate, lastDate)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Detaysız Ekstre - ${receiptSupplier.name}`;
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    const onClickDownloadDetailedReceipt = (firstDate, lastDate) => {
        downloadDetailedSupplierReceipt(receiptSupplier.id, firstDate, lastDate)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Detaylı Ekstre - ${receiptSupplier.name}`;
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                code: row[0],
                name: row[1],
                phone: row[2],
                address: row[3],
                currency: row[4],
                description: row[5]
            })
        }
        uploadSupplierExcelFile(items)
            .then(res => {
                setSupplierPage({ ...pageModel, content: res.data })
                toast.success("Kayıtlar yüklendi")
            }).catch(err => {
                toast.error(EXCEL_VALIDATION_MESSAGE)
            })
    }

    const downloadExcelFile = () => {
        downloadSupplierExcelFile().then(res => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'tedarikçiler.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(err => {
            toast.error('Dosya indirilirken hata oluştu!')
        })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    TEDARİKÇİLER
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Tedarikçi</label>}
                    variant='green'
                    onClick={() => nav('/supplier/add')}
                />
                {/* <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-upload'
                >
                    <RiFileExcel2Fill />
                    <span> Excel Yükle</span>
                </label> */}
                <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-download'
                    onClick={downloadExcelFile}
                >
                    <FaCloudDownloadAlt />
                    <span> Excel İndir</span>
                </label>
                {/* <input className='hidden' id='excel-upload' type='file' accept='.xls, .xlsx' onChange={e => uploadExcelFile(e)} /> */}
            </div>
            <table className='w-full text-left text-zinc-900 mb-10'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-1/12'>Ted. Kodu</th>
                        <th className='p-2 w-3/12'>Tedarikçi Adı</th>
                        <th className='p-2 w-1/24'>Kur</th>
                        {/* <th className='p-2 w-1/12'>Telefon</th> */}
                        <th className='p-2 w-2/12'>Borç</th>
                        <th className='p-2 w-2/12'>Alacak</th>
                        <th className='p-2 w-2/12'>Bakiye</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                value={searchParams.id}
                                onChange={e => dispatch(setSupplierSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Tedarikçi kodu...'
                                value={searchParams.code}
                                onChange={e => dispatch(setSupplierSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Tedarikçi adı...'
                                value={searchParams.name}
                                onChange={e => dispatch(setSupplierSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                    </tr>
                    {
                        supplierPage.content.map((supplier, index) => (
                            <tr key={index} className='border-b items-center text-sm hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {supplier.id} </td>
                                <td className='p-2'>{supplier.code} </td>
                                <td className='p-2'>{supplier.name}</td>
                                <td className='p-2'>{supplier.currency}</td>
                                {/* <td className='p-2'>{supplier.phone}</td> */}
                                <td className='p-2'>{formatNumber(supplier.debt)} {supplier.currency}</td>
                                <td className='p-2'>{formatNumber(supplier.credit)} {supplier.currency}</td>
                                <td className='p-2'>{formatNumber(supplier.balance)} {supplier.currency}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/supplier/edit/${supplier.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(supplier.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                        <span className='cursor-pointer hover:scale-125 hover:text-green-600 duration-150' onClick={() => nav(`/supplier/${supplier.id}/payment`)}>
                                            <MdPayments />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-zinc-600 duration-150'
                                            onClick={() => {
                                                setReceiptSupplier(supplier)
                                                setIsOpenReceiptModal(true)
                                            }}
                                        >
                                            <IoReceiptSharp />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={supplierPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
            <SupplierReceipt
                isOpen={isOpenReceiptModal}
                closeModal={() => setIsOpenReceiptModal(false)}
                onClick={(firstDate, lastDate) => onClickDownloadReceipt(firstDate, lastDate)}
                onClickDetailed={(firstDate, lastDate) => onClickDownloadDetailedReceipt(firstDate, lastDate)}
            />
        </div >
    )
}

export default SupplierListPage